import { Injectable } from '@angular/core';
import { ApiService } from "../api.service";
import { IntegrationDTO } from '../integrations/Integration';

const PATH = "integrations";

@Injectable({
  providedIn: 'root'
})
export class IntegrationsHandlerService {

  constructor(private APIService: ApiService) { }

  getIntegrations(masterAccountID?: number, appID?: number, queryParams?: {
    paginated: boolean,
    type?: string;
  },){
    return this.APIService.get(`${PATH}/${masterAccountID || 'null'}/${appID || 'null'}`, {
      params: queryParams,
    })
  }

  getIntegration(masterAccountID: number, integrationID: number, appID?: number,) {
    return this.APIService.get(`${PATH}/${masterAccountID || 'null'}/${appID || 'null'}/${integrationID}`);
  }

  deleteIntegration(masterAccountID: number, integrationID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${integrationID}`);
  }

  postIntegration(masterAccountID: number, integrationDTO: IntegrationDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, integrationDTO);
  }

  putIntegration(masterAccountID: number, integrationDTO: IntegrationDTO) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${integrationDTO.id}`,
      integrationDTO,
    );
  }

  getIntegrationUsageReport(masterAccountID: number, integrationID: string, queryParams: {
    start_date: string;
    end_date: string;
    include_tests?: boolean;
  }) {
    return this.APIService.get(`${PATH}/${masterAccountID}/usage-report/${integrationID}`, {
      params: queryParams,
    });
  }

  getThreadFeedbackList(masterAccountID: number, integrationID: number, queryParams: {
    start_date: string;
    end_date: string;
    page?: number;
    perPage?: number;
    include_tests?: boolean;
  }) {
    return this.APIService.get(`${PATH}/${masterAccountID}/thread-feedback/${integrationID}`, {
      params: queryParams,
    });
  }

  getThreadList(masterAccountID: number, integrationID: number, queryParams: {
    start_date: string;
    end_date: string;
    page?: number;
    perPage?: number;
    include_tests?: boolean;
  }) {
    return this.APIService.get(`${PATH}/${masterAccountID}/thread-list/${integrationID}`, {
      params: queryParams,
    });
  }

  exportThreadListPdf(masterAccountID: number, integrationID: number, queryParams: {
    start_date: string;
    end_date: string;
    include_tests?: boolean;
  }) {
    return this.APIService.get(`${PATH}/${masterAccountID}/thread-list/${integrationID}/export-pdf`, {
      params: queryParams,
    });
  }

  getThreadDetail(masterAccountID: number, integrationID: number, threadID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/thread-detail/${integrationID}/${threadID}`);
  }

  generateSecret(masterAccountID: number, integrationID: number) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${integrationID}/generate-secret`, {});
  }

  computeIdentityHash(masterAccountID: number, integrationID: number, externalUserId: string) {
    return this.APIService.post(`${PATH}/${masterAccountID}/${integrationID}/compute-identity-hash`, {
      external_user_id: externalUserId,
    });
  }

}
